<p-toast key="main" position="top-right" [baseZIndex]="10000"></p-toast>
<p-confirmDialog key="main" header="Confirm" icon="pi pi-exclamation-triangle"></p-confirmDialog>
<p-confirmDialog header="Confirm" icon="pi pi-exclamation-triangle"></p-confirmDialog>
<router-outlet></router-outlet>
